export const BASKETS_QUERY_KEY = 'pmi.web.office__shared_baskets';
export const TTL = 900000; // 15 minutes in milliseconds
